import React from 'react';
import avatar from '../../Assets/images/legacy/avatar.jpg';
import profileData from './profile.json';
import LegacyProjectCard, { LegacyProject } from './LegacyProjectCard';
import './LegacyHome.scss';

type LegacyProfile = {
  data: {
    projects: LegacyProject[];
  };
};

const profile = profileData as LegacyProfile;

const LegacyHome: React.FC = () => (
  <main className="legacy-homepage">
    <div className="legacy-portrait">
      <img className="legacy-avatar" src={avatar} alt="Me out hiking!" />
    </div>

    <section className="legacy-jumbotron" aria-labelledby="legacy-title">
      <span>Hello! My name is </span>
      <h1 id="legacy-title">Jason Conci.</h1>
      <hr />
      <p>I'm a 22 year old software engineer, based in San Francisco, CA.</p>
    </section>

    <section className="legacy-section" aria-labelledby="legacy-about">
      <div className="legacy-section-heading">
        <span className="legacy-section-number">01.</span>
        <h2 id="legacy-about">About Me</h2>
      </div>
      <hr className="legacy-about-rule" />
      <p>
        Ever since I was a little kid with a bucket of LEGOs &amp; a pet rat to
        build houses for, I've loved making things for people &amp; pets alike.
        Whether it's programming, music, photography, cars, or IKEA furniture,
        you can hand me the pieces, and I'll gleefully hand you the product -
        Now, with my degree from Gonzaga University, only-slightly-bridled lust
        for life, and freshly loaded Starbucks card, I'm ready to be your newest
        go-to dev.
      </p>
    </section>

    <section className="legacy-section" aria-labelledby="legacy-programming">
      <div className="legacy-section-heading">
        <span className="legacy-section-number">02.</span>
        <h2 id="legacy-programming">Programming</h2>
      </div>
      <hr className="legacy-projects-rule" />
      <p>
        I recently graduated from Gonzaga University with a Bachelor of Science
        in Computer Science, achieving an upper division cumulative GPA of 3.87.
      </p>
      <p>I usually work with these tools:</p>
      <div className="legacy-lists">
        <div>
          <h3>Languages:</h3>
          <ul>
            <li>Python</li>
            <li>Java</li>
            <li>SQL</li>
            <li>C++</li>
            <li>JavaScript</li>
            <li>React (Redux)</li>
            <li>Haskell</li>
          </ul>
        </div>
        <div>
          <h3>Tools:</h3>
          <ul>
            <li>UML</li>
            <li>Docker</li>
            <li>Git/GitHub</li>
            <li>AWS</li>
            <li>Linux</li>
            <li>Agile</li>
          </ul>
        </div>
      </div>
      <p>And here are some projects I've worked on:</p>
      <div className="legacy-project-grid">
        {profile.data.projects.map((project) => (
          <LegacyProjectCard project={project} key={project.title} />
        ))}
      </div>
    </section>

    <section className="legacy-section" aria-labelledby="legacy-contact">
      <div className="legacy-section-heading">
        <span className="legacy-section-number">03.</span>
        <h2 id="legacy-contact">Contact</h2>
      </div>
      <hr className="legacy-contact-rule" />
      <p>
        The best way to get in touch with me is through email,{' '}
        <a href="mailto:jasonjconci@gmail.com">jasonjconci@gmail.com</a>. Feel
        free to reach out to me there, or via any other platform listed at the
        top!
      </p>
    </section>
  </main>
);

export default LegacyHome;
